import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import CheckoutReviewAndSubmitState from "@store/Store/Pages/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitState";
import { Draft } from "immer";

const initialState: CheckoutReviewAndSubmitState = {
    deliveryTrackingPhoneNumberValidOrEmpty: true,
    emptyShipVia: false,
    isValidatingAdyenPayment: false,
};

const reducer = {
    "Store/Pages/CheckoutReviewAndSubmit/SetDeliveryTrackingPhoneNumber": (
        draft: Draft<CheckoutReviewAndSubmitState>,
        action: { deliveryTrackingPhoneNumber: string; deliveryTrackingPhoneNumberValidOrEmpty: boolean },
    ) => {
        draft.deliveryTrackingPhoneNumber = action.deliveryTrackingPhoneNumber;
        draft.deliveryTrackingPhoneNumberValidOrEmpty = action.deliveryTrackingPhoneNumberValidOrEmpty;
    },
    "Store/Pages/CheckoutReviewAndSubmit/SetEmptyShipVia": (
        draft: Draft<CheckoutReviewAndSubmitState>,
        action: {emptyShipVia: boolean},
    ) => {
        draft.emptyShipVia = action.emptyShipVia;
    },
    "Store/Pages/CheckoutReviewAndSubmit/IsValidatingAdyenPayment": (
        draft: Draft<CheckoutReviewAndSubmitState>,
        action: {isValidatingAdyenPayment: boolean},
    ) => {
        draft.isValidatingAdyenPayment = action.isValidatingAdyenPayment;
    },
};

const checkoutReviewAndSubmitReducer = createTypedReducerWithImmer(initialState, reducer);

export default checkoutReviewAndSubmitReducer;
